import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from "vue";
import { getData } from "@/services/axios";

import { ref, computed, watch, provide } from 'vue';
import { isAuthenticatedKey, meKey, allSchoolListKey, isHaveSchoolTypeKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default {
  __name: 'App',
  setup: function setup(__props) {
    // @ts-check
    var isAuthenticated = ref(false);
    var me = ref({});
    var allSchoolList = ref([]);
    var isHaveSchoolType = computed(function () {
      return {
        el: allSchoolList.value.some(function (v) {
          return v.type === "el";
        }),
        jh: allSchoolList.value.some(function (v) {
          return v.type === "jh";
        }),
        hs: allSchoolList.value.some(function (v) {
          return v.type === "hs";
        }),
        ss: allSchoolList.value.some(function (v) {
          return v.type === "ss";
        })
      };
    });
    watch(function () {
      return Vue.prototype.$auth.isAuthenticated;
    }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!Vue.prototype.$auth.isAuthenticated) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return Promise.all([getData("me"), getData("school?with=count")]);
          case 1:
            data = _context.v;
            me.value = data[0];
            allSchoolList.value = data[1].items;
          case 2:
            isAuthenticated.value = Vue.prototype.$auth.isAuthenticated;
          case 3:
            return _context.a(2);
        }
      }, _callee);
    })));
    provide(isAuthenticatedKey, isAuthenticated);
    provide(meKey, me);
    provide(allSchoolListKey, allSchoolList);
    provide(isHaveSchoolTypeKey, isHaveSchoolType);
    return {
      __sfc: true,
      isAuthenticated: isAuthenticated,
      me: me,
      allSchoolList: allSchoolList,
      isHaveSchoolType: isHaveSchoolType
    };
  }
};